/* DEPRECATED. This now serves as an adapter for the CompanyAddress component.
 * If you're here, you probably want to be there instead.
 */
import React from "react";
import { COMPANY } from "APP_ROOT/constants";
import { translateProps, renderIf } from "MODULES/shared/decorators";
import { findMatch } from "LIB/arrays";
import CompanyAddress from "./CompanyAddress";

const withProps = translateProps(({ names, ...props }) => {
  const findInput = name => props[findMatch(names, name)];
  return {
    shippingType: findInput("type"),
    companyId: findInput("company_id"),
    addressId: findInput("address_id"),
    addressPh: findInput("address_phone")
  };
});

const forCompanyShipping = renderIf(
  ({ shippingType }) => shippingType.input.value === COMPANY
);

export default withProps(
  forCompanyShipping(props => <CompanyAddress {...props} />)
);



// WEBPACK FOOTER //
// ./app/modules/Orders/shared/ShippingFields/CompanyFields.jsx